<template>
  <sweet-modal
      :title="$t('modal_businessUnits_removeUserFromBu')"
      blocking
      width="600px"
      ref="removeUserFromBu"
      class="modal"
      v-on:close="close">
    <el-form :model="form" status-icon :rules="rules" ref="form" class="demo-ruleForm">
      <el-form-item prop="userId" size="mini">
        <el-select v-model="form.userId" :placeholder="$t('modal_businessUnits_team')">
          <el-option
              v-for="user in list"
              :key="user.id"
              :label="user.user.fullName"
              :value="user.id"
              @click.native="handleSelectUser(user.id)">
            <span :class="{ 'is-manager': isManager(user.id) }">{{ user.user.fullName }}</span>
          </el-option>
        </el-select>
<!--        <div v-if="isManager(form.userId)" class="is-manager">Manager can't be removed</div>-->
      </el-form-item>
      <el-button size="medium" @click="remove('form')" type="primary">{{$t('general_remove')}}</el-button>
    </el-form>
  </sweet-modal>
</template>

<script>
import { SweetModal } from '@totalflow4/tfsweet-modal-vue'
import axios from 'axios'
export default {
  name: "RemoveUserFromBUModal",
  components: {
    SweetModal
  },
  data(){
    const checkDate = (rule, value, callback) => {
      if (value && this.isManager(this.form.userId)) {
        return callback(new Error('Manager can\'t be removed'));
      }else callback();
    };
    return {
      list: [],
      businessUnitId: null,
      form: {
        userId: null
      },
      rules: {
        userId: [{ validator: checkDate, trigger: 'change' }]
      },
      managerCompanyUserId: null
    }
  },
  methods: {
    async openModal(companyId, businessUnitId){
      try {
        this.businessUnitId = businessUnitId

        const userList = await this.directories(companyId, businessUnitId)

        const selectedUsers = await this.item(companyId, businessUnitId)

        if (userList.length && selectedUsers.length) {
          selectedUsers.map((val) => {
            this.list = this.list.concat(userList.filter(bal => bal.id === val))
          })
        }

        this.$refs.removeUserFromBu.open()

      } catch (err) {
        console.log(err)
      }
    },
    directories(companyId, businessUnitId){
      return new Promise((resolve, reject) => {
        let loader = this.$loading.show();
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        axios.post(`/api/v1/businessUnits/directories?companyId=${companyId}&operation=update&businessUnitId=${businessUnitId}`)
            .then(response => {
              console.log('---', response.data);
              resolve(response.data.companyUserList)
              loader.hide()
            })
            .catch(error => {
              console.log('An error occurred:', error);
              reject(error)
              loader.hide()
            });
      })
    },
    item(companyId, businessUnitId){
      return new Promise((resolve, reject) => {
        let loader = this.$loading.show();
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        axios
            .post(`/api/v1/businessUnits/item?companyId=${companyId}&businessUnitId=${businessUnitId}`)
            .then(response => {
              this.managerCompanyUserId = response.data.item.managerCompanyUserId
              loader.hide()
              resolve(response.data.item.companyUserIdList)
            })
            .catch(error => {
              loader.hide()
              reject(error)
              console.log('An error occurred:', error);
            });
      })
    },
    handleSelectUser(userId){
      console.log('-', userId)
    },
    remove(form) {
      if (this.list.length < 2){
        return this.notification(this.$t('general_warning'), this.$t('notification_cantRemoveLastUserInBU'), "info")
      }
      this.$refs[form].validate((valid) => {
        if (valid) {
          const loader = this.$loading.show();
          axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
          axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
          axios
              .get(`/api/v1/businessUnits/deleteUserInBu?companyId=${this.$route.query.companyId}&businessUnitId=${this.businessUnitId}&companyUserId=${this.form.userId}`)
              .then(response => {
                console.log(response)
                loader.hide()
                this.$refs.removeUserFromBu.close()
                this.notification(this.$t('general_success'), this.$t('notification_userSuccessfullyRemoved'), "success")
                this.$emit('loadList')
              })
              .catch(error => {
                console.log('An error occurred:', error);
                loader.hide()
              });
        }
      })
    },
    notification(title, message, type) {
      this.$notify({
        title: title,
        message: message,
        type: type
      });
    },
    close(){
      this.$refs['form'].resetFields()
      this.list = []
      this.form.userId = null
      this.businessUnitId = null
      this.managerCompanyUserId = null
    },
    isManager(userId) {
      return this.managerCompanyUserId === userId
    }
  }
}
</script>

<style lang="less" scoped>
.is-manager {
  color: red !important;
}
</style>
